import React, {useState} from 'react'
import PropTypes from 'prop-types'
import TextInput from '../../TextInput'
import SelectInput from '../../SelectInput'
import {DayMap, OpenHourOptions} from './chatSettingConstants'
import {makeStyles} from '@mui/styles'
import {spaceMedium} from '../../../assets/styles/spacing'

function SingleDeskHourScheduleInput(props) {
  const classes = useStyles()
  const [closeTimeOptions, setCloseTimeOptions] = useState(
    props.value.openTime
      ? OpenHourOptions.filter(t => {
          return parseInt(t.value) > props.value.openTime
        })
      : OpenHourOptions,
  )
  const [inValidFields, setInvalidFields] = useState(['date', 'openTime', 'closeTime'])

  const handleStartTimeChange = openTime => {
    props.onChange({...props.value, openTime: parseInt(openTime)})
    let newETOptions = OpenHourOptions.filter(t => {
      return parseInt(t.value) > parseInt(openTime)
    })

    setCloseTimeOptions(newETOptions)
    setInvalidFields([...inValidFields].filter(e => e !== 'openTime'))
  }

  const handleCloseTimeChange = time => {
    props.onChange({...props.value, closeTime: parseInt(time)})
    setInvalidFields([...inValidFields].filter(e => e !== 'closeTime'))
  }

  return (
    <div className={classes.inputContainer}>
      <TextInput isDisabled={true} label={'Day of week'} isRequired={true} value={DayMap[props.value.dayOfWeek]} />
      <SelectInput
        onChange={handleStartTimeChange}
        label={'Hours open start'}
        isRequired={true}
        options={OpenHourOptions}
        value={'' + (typeof props.value.openTime === 'number' ? props.value.openTime : '')}
        error={props.error && inValidFields.includes('openTime')}
      />
      <SelectInput
        onChange={handleCloseTimeChange}
        label={'Hours open end'}
        isRequired={true}
        options={closeTimeOptions}
        value={'' + (typeof props.value.closeTime === 'number' ? props.value.closeTime : '')}
        disabled={typeof props.value.openTime !== 'number'}
        error={props.error && inValidFields.includes('closeTime')}
      />
    </div>
  )
}

const useStyles = makeStyles(theme => ({
  inputContainer: {
    display: 'flex',
    alignItems: 'flex-start',
    marginBottom: spaceMedium,
    width: '100%',
    gap: theme.spacing(3),

    '&:last-child': {
      marginBottom: 0,
    },
  },
}))

SingleDeskHourScheduleInput.propTypes = {
  value: PropTypes.shape({
    dayOfWeek: PropTypes.number, // 0 = Sunday, 6 = Saturday
    openTime: PropTypes.number, // in minutes since midnight
    closeTime: PropTypes.number, // in minutes since midnight
  }),
  onChange: PropTypes.func.isRequired,
  error: PropTypes.bool,
}

export default SingleDeskHourScheduleInput
